import { render, staticRenderFns } from "./MoviesSlider.vue?vue&type=template&id=1ff6f014&"
import script from "./MoviesSlider.vue?vue&type=script&lang=js&"
export * from "./MoviesSlider.vue?vue&type=script&lang=js&"
import style0 from "./MoviesSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports